import {Params} from '../getConfig'

export const amplifyDevelopment: Params = {
  aws_user_pools_id: 'eu-west-1_BdQ3nsIJ8',
  aws_cognito_identity_pool_id:
    'eu-west-1:fa22d0ef-e740-43c2-ab4e-ffd378536ec1',
  aws_user_pools_web_client_id: '38999p0g7t0cotb0scui0c8p02',
  oauth_domain: 'development.dev-authentication.fih.io',
  aws_user_files_s3_bucket: 'development-profile-pictures-dev'
}
